// extracted by mini-css-extract-plugin
export default {"button":"SubmitButton_button__AOk5h","rainbow":"SubmitButton_rainbow__qdlSj"};